<template>
    <div>
        <form novalidate class="md-layout" @submit.prevent="validateUser" :class="`md-alignment-top-center`">
            <md-card class="md-layout-item md-size-50 md-small-size-100">
                <md-card-header>
                    <div class="md-title">小云客户设备管理系统</div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('userAccount')">
                                <label for="user_account">用户账号</label>
                                <md-input name="user_account" id="user_account" type="tel"
                                          v-model="form.userAccount" :disabled="sending" maxlength="11"/>
                                <span class="md-error"
                                      v-if="!$v.form.userAccount.required">必须输入用户账号</span>
                                <span class="md-error"
                                      v-else-if="!$v.form.userAccount.minlength">账号格式不正确</span>
                            </md-field>
                        </div>

                    </div>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('verificationCode')">
                                <label for="verification_code">验证码</label>
                                <md-input name="verification_code" id="verification_code"
                                          v-model="form.verificationCode" :disabled="sending"
                                          maxlength="6"/>
                                <span class="md-error"
                                      v-if="!$v.form.verificationCode.required">必须输入验证码</span>
                                <span class="md-error"
                                      v-else-if="!$v.form.verificationCode.minlength">验证码格式不正确</span>
                            </md-field>
                        </div>

                        <md-button class="md-raised md-accent" v-bind:disabled="isCountDown || sending"
                                   v-on:click="getVerification">{{countDownText}}
                        </md-button>

                    </div>

                </md-card-content>
                <md-progress-bar md-mode="indeterminate" v-if="sending"/>

                <md-card-actions>
                    <md-button type="submit" class="md-raised md-primary" :disabled="sending">登录</md-button>
                </md-card-actions>
            </md-card>

            <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
        </form>
        <footer id="footer">
            深圳市云动技术科技有限公司
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow" class="slide slide-ct"
               hotrep="hp.footer.bottom.miitbeian">粤ICP备2020093498号</a>
        </footer>
    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {
        required,
        minLength,
    } from 'vuelidate/lib/validators'

    export default {
        name: "Login",
        mixins: [validationMixin],
        data: () => ({
            form: {
                userAccount: null,
                verificationCode: null,
            },
            sending: false,
            timer: '',
            isCountDown: false,
            countDownText: '获取验证码',
            countDown: '',
            toast: false,
            toastMsg: "",
        }),
        validations: {
            form: {
                userAccount: {
                    required,
                    minLength: minLength(11),
                },
                verificationCode: {
                    required,
                    minLength: minLength(4),
                },
            }
        },
        methods: {
            getValidationClass(fieldName) {
                const field = this.$v.form[fieldName]

                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty
                    }
                }
            },
            startCountDown: function () {
                this.countDown--;
                window.console.log('countDown' + this.countDown)
                this.countDownText = '获取验证码（' + this.countDown + "）"
                if (this.countDown <= 0) {
                    this.stopCountDown();
                }
            },
            stopCountDown: function () {
                window.console.log('stopCountDown')
                clearInterval(this.timer);
                this.isCountDown = false;
                this.countDownText = '获取验证码';
            },
            getVerification() {
                this.sending = true
                this.$http.get('/api/user/verification/' + this.form.userAccount + '/xiaoyun/?from=1')
                    .then(response => {
                        this.sending = false
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('获取验证码成功');
                                window.console.log('startCountDown' + this.countDown)
                                this.isCountDown = true;
                                this.countDown = 60;
                                this.timer = setInterval(this.startCountDown, 1000);
                            } else {
                                switch (data.code) {
                                    case 1000:
                                        this.showErrorTips('账号格式不正确（1000）');
                                        break
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    case 2500:
                                        this.showErrorTips('短信网关错误（2500）');
                                        break
                                    default:
                                        this.showErrorTips('获取验证码失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('获取验证码请求失败，HTTP错误码' + response.status);
                        }
                    }).catch(error => {
                    this.sending = false
                    this.showErrorTips('未知错误' + error);
                })
            },
            login() {
                this.sending = true
                this.$http.post('/api/user/login/?from=1', {
                    account: this.form.userAccount,
                    verification: this.form.verificationCode
                }).then(response => {
                    this.sending = false
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            localStorage.setItem('user_data', response.headers['token'])
                            localStorage.setItem('user_info', JSON.stringify(data.data));
                            this.$router.replace('/dashboard')
                        } else {
                            switch (data.code) {
                                case 2000:
                                    this.showErrorTips('账号或验证码不正确（2000）');
                                    break
                                case 3000:
                                    this.showErrorTips('当前账号没有权限（3000）');
                                    break;
                                case 2100:
                                    this.showErrorTips('验证码已过期，请重新获取（2100）');
                                    break
                                default:
                                    this.showErrorTips('登录失败，服务器返回错误码' + data.code);
                                    break
                            }
                        }
                    } else {
                        this.showErrorTips('登录失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.sending = false
                    this.showErrorTips('未知错误' + error);
                })
            },
            showTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            showErrorTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            validateUser() {
                this.$v.$touch()

                if (!this.$v.$invalid) {
                    this.login()
                }
            },
        }
    }
</script>

<style scoped>
    .md-progress-bar {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
    }

    form {
        padding-top: 10%;
    }

    #footer {
        position: fixed;
        bottom: 10px;
        right: 20px;
    }
</style>